// Self-contained data for the T&C Rental and Event Services events concept website.
export const BUSINESS = {
  "slug": "tc-rental-event-services-concept",
  "media": {
    "hero": "/events/tc-rental/07.jpg",
    "logo": null,
    "gallery": [
      "/events/tc-rental/01.jpg",
      "/events/tc-rental/02.jpg",
      "/events/tc-rental/03.jpg",
      "/events/tc-rental/04.jpg",
      "/events/tc-rental/05.jpg",
      "/events/tc-rental/06.jpg",
      "/events/tc-rental/08.jpg",
      "/events/tc-rental/09.jpg",
      "/events/tc-rental/10.jpg",
      "/events/tc-rental/11.jpg",
      "/events/tc-rental/12.jpg",
      "/events/tc-rental/13.jpg",
      "/events/tc-rental/14.jpg",
      "/events/tc-rental/15.jpg",
      "/events/tc-rental/16.jpg",
      "/events/tc-rental/17.jpg",
      "/events/tc-rental/18.jpg",
      "/events/tc-rental/19.jpg",
      "/events/tc-rental/20.jpg",
      "/events/tc-rental/21.jpg",
      "/events/tc-rental/22.jpg"
    ]
  },
  "name": "T&C Rental and Event Services",
  "shortName": "T&C Rental",
  "kind": "rental",
  "layout": "catalogue",
  "location": "Cebu City · serving Cebu and Bohol",
  "address": "2177 Don Gil Garcia St., Cebu City 6000, Philippines",
  "eyebrow": "Event furniture · Cebu and Bohol",
  "headline": "Build the room, one considered piece at a time.",
  "intro": "Discover real furniture categories and assemble a clearer availability request.",
  "lead": "Debbie Paez Rojonan",
  "leadRole": "Proprietor / chief executive identified by D&B",
  "products": [
    "Crossback Chairs",
    "Louis Chairs",
    "Acrylic Napoleon Chairs",
    "Classic Farm Tables",
    "Cabriole Tables",
    "Wood Furniture",
    "Glass Furniture"
  ],
  "productMedia": [
    "/events/tc-rental/03.jpg",
    "/events/tc-rental/10.jpg",
    "/events/tc-rental/02.jpg",
    "/events/tc-rental/19.jpg",
    "/events/tc-rental/22.jpg",
    "/events/tc-rental/07.jpg",
    "/events/tc-rental/18.jpg"
  ],
  "services": [
    "Furniture rental",
    "Party equipment rental",
    "Tent rental",
    "Truck rental",
    "Cebu and Bohol event support"
  ],
  "proof": [
    "Design-oriented furniture catalogue",
    "Cebu and Bohol operations",
    "Credited on a published wedding feature"
  ],
  "reviewSnapshot": "Public sources showed about 4.8–4.9/5 with 10–11+ reviews when checked in August 2026.",
  "reviews": [
    {
      "author": "Community recommendation",
      "summary": "Recommended T&C for Cebu and Bohol wedding and event rentals and highlighted its long local-industry presence; the exact number of years remains unverified.",
      "source": "https://www.reddit.com/r/WeddingsPhilippines/comments/1h0us5e/table_and_chair_rentals/",
      "explicitStars": null,
      "context": "Rental recommendation"
    }
  ],
  "contact": {
    "phone": "(032) 417-1291",
    "phoneHref": "+63324171291",
    "email": "open2dpub@yahoo.com"
  },
  "sources": [
    "https://www.bizippines.com/t-c-rental-and-event-services-032-417-1291",
    "https://www.dnb.com/business-directory/company-profiles.tc_rental_and_event_services.cde555c0e1210b7ceae0735badd09d66.html",
    "https://www.evepla.com/PH/Guadalupe/157255160981863/T%26C-Rental-and-Event-Services",
    "https://brideandbreakfast.ph/2021/02/12/vern-enciso-ben-lim-official-photos/"
  ]
};
